angular.module('unergie.main')
.directive('indicator', (AlertManager, BoFeaturesService, AccountService, $uibModal, $filter, DataAccess, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/indicator/indicator.html',
        scope: {
            pictoUrl: '=',
            bgColor: '=',
            number: '=',
            total: '=',
            title: '=',
            explanation: '=',
            suffix: '=',
            clickAction: '=',
        },
        link($scope) {
            $scope.getPercentage = function () {
                const percent = ((100 * Number($scope.number)) / Number($scope.total)).toFixed(0)
                $scope.widthStyle = { width: `${percent}%` }
                return percent
            }

            $scope.action = function () {
                if ($scope.clickAction) {
                    $scope.refresh = true
                    return $scope.clickAction()
                    .finally(() => ($scope.refresh = false))
                }
            }
        },
    }),
)
